import * as Yup from 'yup';

export default Yup.object().shape({
  supplier: Yup.object().shape({
    source: Yup.string().required(
      'Please let us know how you heard about Feast It.'
    ),
  }),
});
